/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React, { useState, useMemo } from "react";

const useTemplateListing = (data, groupByKey, searchKeys, groupOrder = []) => {
  const [searchTerm, setSearchTerm] = useState('');

  const groupedData = useMemo(() => {
    const filteredData = data.filter(item =>
      searchKeys.some(key =>
        item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );

    const grouped = filteredData.reduce((acc, item) => {
      const groupKey = item[groupByKey]?.charAt(0).toUpperCase() + item[groupByKey]?.slice(1) || '#'; 
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);
      return acc;
    }, {});

    // If groupOrder is provided, enforce it explicitly
    const orderedGroups = {};
    groupOrder.forEach(key => {
      orderedGroups[key] = grouped[key] || []; // Include key from order, even if empty
    });

    // Add any remaining groups not listed in groupOrder
    Object.keys(grouped).forEach(key => {
      if (!orderedGroups[key]) {
        orderedGroups[key] = grouped[key];
      }
    });

    return orderedGroups;
  }, [data, searchTerm, groupByKey, searchKeys, groupOrder]);

  return { groupedData, searchTerm, setSearchTerm };
};

export default useTemplateListing;